import {createReducer} from 'typesafe-actions';
import {VodInfoState, VodInfoAction} from 'modules/vodInfo/types';
import {getVodInfoAsync} from 'modules/vodInfo/actions';
import {
  asyncState,
  createAsyncReducer,
  transformToArray,
} from 'lib/reducerUtils';

const initialState: VodInfoState = {
  titleFileInfo: asyncState.initial(),
};

const vodInfo = createReducer<VodInfoState, VodInfoAction>(
  initialState,
).handleAction(
  transformToArray(getVodInfoAsync),
  createAsyncReducer(getVodInfoAsync, 'titleFileInfo'),
);

export default vodInfo;
